import {
  checkHasAnalysis,
  createChart,
  createSearchWithChart,
  deleteChart,
  duplicateChart,
  fetchChartFeedbackList,
  fetchChartTable,
  getChart,
  getChartList,
  toggleStarChart,
  updateChart,
} from '@/entities/chart/api';

const chartService = {
  fetchChartList: getChartList,
  fetchChart: getChart,
  createChart,
  updateChart,
  deleteChart,
  toggleStarChart,
  fetchTable: fetchChartTable,
  fetchChartFeedbackList,
  duplicateChart,
  createSearchWithChart,
  checkHasAnalysis,
};

export default chartService;
